export const init = () => {
	const multi = document.querySelectorAll('.js-file-multi');
	if (!multi) {
		return;
	}
	console.log('multiiii');
	let dt;
	function deleteItem() {
		const inpBlock = this.closest('.inp-multi__block');
		const inpParent = this.closest('.inp-multi');
		const inp = inpParent.querySelector('.js-file-multi');
		const parentFiles = this.closest('.js-files-names');
		const files = Array.from(parentFiles.querySelectorAll('.inp-multi__block'));
		const ind = files.indexOf(inpBlock);
		inpBlock.remove();
		dt.items.remove(ind);
		inp.files = dt.files;
	}

	dt = new DataTransfer();
	function multiFileChange(e) {
		const parent = this.closest('.inp-multi');
		const namesArea = parent.querySelector('.js-files-names');
		namesArea.innerHTML = '';
		console.log(this.files);
		const files = Array.from(this.files);
		let size = 0;
		const icon = document
			.createRange()
			.createContextualFragment(
				'<span class="icon-svg icon-svg--upload" aria-hidden="true"><svg class="icon-svg__svg" xmlns:xlink="http://www.w3.org/1999/xlink"><use xlink:href="../img/bg/icons-svg.svg#icon-upload" width="100%" height="100%" focusable="false"></use></svg></span>',
			);
		files.forEach((item) => {
			const block = document.createElement('span');
			block.classList.add('inp-multi__block');
			const name = document.createElement('span');
			name.classList.add('inp-multi__name');
			const btn = document.createElement('span');
			btn.classList.add('inp-multi__delete');
			btn.classList.add('js-multi-delete');
			name.appendChild(icon);
			//name.textContent = item.name;
			block.appendChild(name);
			block.appendChild(btn);
			namesArea.appendChild(block);
			btn.addEventListener('click', deleteItem);
			dt.items.add(item);
			size += item.size;
		});
		const i = parseInt(Math.floor(Math.log(size) / Math.log(1024)), 10);
		//console.log(size, i, `${(size / 1024 ** i).toFixed(1)}`);
		const mb = size / 1024 / 1000;
		console.log(size / 1024 / 1000, Math.round(mb));
		console.log(dt);
	}
	const files = [].slice.call(document.querySelectorAll('.js-file'));
	if (files) {
		files.forEach((item) => {
			item.addEventListener('change', fileChange);
		});
	}
	const multifiles = [].slice.call(document.querySelectorAll('.js-file-multi'));
	if (multifiles) {
		multifiles.forEach((item) => {
			item.addEventListener('change', multiFileChange);
		});
	}
};
